import { render, staticRenderFns } from "./dataRowEvolVar.vue?vue&type=template&id=1747dfb0&scoped=true&"
import script from "./dataRowEvolVar.vue?vue&type=script&lang=js&"
export * from "./dataRowEvolVar.vue?vue&type=script&lang=js&"
import style0 from "./dataRowEvolVar.vue?vue&type=style&index=0&id=1747dfb0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1747dfb0",
  null
  
)

export default component.exports